import React from 'react';
import cn from 'classnames';
import styles from './CellText.module.scss';

const CellText = ({ className, ...props }) => {
  return <p {...props} className={cn(styles.root, className)} />;
};

export default CellText;
